/**
 * Stable non-negative FNV-1a hash used across the prototype's demo-data
 * generators (driver itineraries, boards, message stream). Keeping a single
 * implementation here avoids drift between the modules that seed the universe.
 */
export function hash(seed: string): number {
  let h = 2166136261;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}
